import { render } from "./RTLModeSwitch.vue?vue&type=template&id=413b42e8&ts=true"
import script from "./RTLModeSwitch.vue?vue&type=script&lang=ts"
export * from "./RTLModeSwitch.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__